<template>
  <div class="order-skeleton">
    <SkeletonAnimation>
      <div v-for="item in 3" :key="item" class="order-list">
        <div class="block1"></div>
        <div class="common-flex">
          <div class="felx-left">
            <div class="block2"></div>
          </div>
          <div class="flex-right">
            <div class="block3"></div>
            <div class="block4"></div>
          </div>
        </div>
        <div class="common-flex flex-color">
          <div class="felx-left">
            <div class="block5"></div>
            <div class="block6"></div>
          </div>
          <div class="flex-right">
            <div class="block7"></div>
          </div>
        </div>
        <div class="list-bottom">
          <div class="block8"></div>
          <div class="block9"></div>
        </div>
      </div>
    </SkeletonAnimation>
  </div>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
export default {
  name: 'HomeSkeletonH5',
  components: {
    SkeletonAnimation,
  },
};
</script>
<style lang="scss" scoped>
.order-skeleton {
  padding: rem(40) rem(24);
}
.order-list {
  height: rem(448);
  border-radius: rem(12);
  background: #ffffff;
  border-radius: rem(12);
  margin: 0 auto;
  margin-bottom: rem(20);
  padding: rem(40) rem(18);
}
.common-flex {
  display: flex;
}
.block1 {
  width: rem(288);
  height: rem(36);
  background: #e5e5eb;
  border-radius: rem(4);
  margin-bottom: rem(32);
}
.block2 {
  width: rem(80);
  height: rem(80);
  background: #e5e5eb;
  border-radius: rem(40);
  margin-bottom: rem(26);
  margin-right: rem(16);
}
.block3 {
  width: rem(400);
  height: rem(32);
  background: #e5e5eb;
  border-radius: rem(4);
  margin-bottom: rem(10);
}
.block4 {
  width: rem(192);
  height: rem(42);
  background: #e5e5eb;
  border-radius: rem(4);
}
.flex-color {
  height: rem(124);
  background: #f8f8f8;
  border-radius: rem(8);
  display: flex;
  align-items: center;
  padding: 0 rem(18);
  justify-content: space-between;
  margin-bottom: rem(38);
}
.block5 {
  width: rem(478);
  height: rem(32);
  background: #e5e5eb;
  border-radius: rem(4);
  margin-bottom: rem(12);
}
.block6 {
  width: rem(271);
  height: rem(28);
  background: #e5e5eb;
  border-radius: rem(4);
}
.block7 {
  width: rem(88);
  height: rem(88);
  background: #e5e5eb;
  border-radius: rem(8);
}
.block8 {
  width: rem(194);
  height: rem(24);
  background: #e5e5eb;
  border-radius: rem(4);
}
.block9 {
  width: rem(205);
  height: rem(36);
  background: #e5e5eb;
  border-radius: rem(4);
}
.list-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
